import { lazy } from 'ice';

import BasicLayout from '@/layouts/BasicLayout';

const Dashboard = lazy(() => import('@/pages/Dashboard'));
const About = lazy(() => import('@/pages/About'));
const Login = lazy(() => import('@/pages/Login'));
const Register = lazy(() => import('@/pages/Register'));
const Test = lazy(() => import('@/pages/Test'));
const Device = lazy(() => import('@/pages/Device'));
const Portmap = lazy(() => import('@/pages/Portmap'));
const routerConfig = [
  {
    path: '/ui',
    component: BasicLayout,
    children: [
      {
        path: '/Login',
        component: Login,
      },
      {
        path: '/Register',
        component: Register,
      },
      {
        path: '/About',
        component: About,
      },
      {
        path: '/Test',
        component: Test,
      },
      {
        path: '/Device',
        component: Device,
      },
      {
        path: '/Portmap',
        component: Portmap,
      },
      {
        path: '/',
        component: Dashboard,
      }
    ],
  },
];
export default routerConfig;
